import { render, staticRenderFns } from "./LeccionD4.vue?vue&type=template&id=522af74a&"
import script from "./LeccionD4.vue?vue&type=script&lang=js&"
export * from "./LeccionD4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports